import React from 'react';
import { Dialog, DialogTitle, DialogContent } from '@mui/material';
import ReactDiffViewer from 'react-diff-viewer-continued';

const DiffViewerDialog = ({ open, onClose, serverKioskUI, currentKioskUI }) => {
    return (
        <Dialog 
            open={open} 
            onClose={onClose}
            maxWidth="lg"
            fullWidth
        >
            <DialogTitle>Custom UI Changes</DialogTitle>
            <DialogContent>
                <ReactDiffViewer
                    oldValue={serverKioskUI || ''}
                    newValue={currentKioskUI || ''}
                    splitView={false}
                    hideLineNumbers={false}
                    showDiffOnly={false}
                    styles={{
                        contentText: {
                            fontFamily: 'monospace',
                            fontSize: '13px'
                        }
                    }}
                />
            </DialogContent>
        </Dialog>
    );
};

export default DiffViewerDialog;

